import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {NotificationLogFilter} from "./notificationLog.filter";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../srvs/lookup";
import {UsageFilter} from "../usage/usage.filter";
import {SmsMtFilter} from "../so/smsMtFilter";

@Component({
  selector: 'micro-notificationLogs',
  templateUrl: './notificationLogs.component.html'
})
export class NotificationLogsComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:NotificationLogFilter = new NotificationLogFilter();
  selectedRow;
  alarmFilter:any;

  usageFilter:UsageFilter = new UsageFilter();
  timer:any;
  reloading:boolean = false;

  settings:any = {
    pageIndex: 0,
    pageSize: 25,
    autoRefresh: false
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient, public lookupService:LookupService) {
  }

  ngOnInit() {

    this.loadSettings();
    this.reload();

    this.timer = setInterval(()=> {
      if (this.settings.autoRefresh) {
        this.reload();
      }
    }, 30000);
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  reload() {
    if (this.reloading) {
      return;
    }

    this.reloading = true;
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.settings.pageSize))
      ;

    if (!this.usageFilter.fromInfinite) {
      params = params.set('from', '' + this.usageFilter.from);
    }

    if (!this.usageFilter.untilInfinite) {
      params = params.set('until', '' + this.usageFilter.until);
    }

    this.http.get(`${this.env.e.url}/notif/notificationLogs`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
        this.reloading = false;
      }
    );
  }

  alarmEvtTime:any;
  selectRow(row) {
    this.selectedRow = row;
    this.alarmEvtTime = new Date(row[0].alarmEvtTime).getTime();
    this.alarmFilter = {value: row[0].alarmFilter};
  }

  addFilterListener() {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.saveSettings();
      this.paginator.pageIndex = 0;
      this.reload();
    });
  }

  addDateRangeListner() {
    this.usageFilter.anyChange.pipe().pipe(debounceTime(500)).subscribe(change => {
      this.saveSettings();
      this.paginator.pageIndex = 0;
      this.reload();
    });
  }

  loadSettings() {
    let sessionSettingsJson = sessionStorage.getItem("notification_log");

    if (sessionSettingsJson) {
      let sessionSettings = JSON.parse(sessionSettingsJson);
      this.settings = sessionSettings.settings;
      this.paginator.pageIndex = this.settings.pageIndex;
      this.paginator.pageSize = this.settings.pageSize;

      this.filter = new NotificationLogFilter(sessionSettings.filter);
      this.addFilterListener();

      this.usageFilter = new UsageFilter(sessionSettings.dateRange);
      this.addDateRangeListner();

    } else {
      this.usageFilter = new UsageFilter();
      this.addDateRangeListner();
      this.filter = new NotificationLogFilter();
      this.addFilterListener();
    }
  }

  saveSettings() {
    let sessionSettings = {
      filter: this.filter.toObj(),
      settings: this.settings,
      dateRange: this.usageFilter.toObj(),
    };
    sessionStorage.setItem("notification_log", JSON.stringify(sessionSettings));
  }

  pagignatorChanged() {
    if (this.paginator.pageIndex !== this.settings.pageIndex || this.paginator.pageSize !== this.settings.pageSize) {
      this.settings.pageIndex = this.paginator.pageIndex;
      this.settings.pageSize = this.paginator.pageSize;
      this.saveSettings();
    }
    this.reload();
  }
}
